export default __webpack_public_path__ + "062e217595cdd51593391301a47c14ce.svg";